export const projectOverviewTypography = {
  sectionTitle: {
    color: '#1D2433',
    fontSize: 17,
    fontWeight: 600,
  },
  kpiLabel: {
    color: '#7A8699',
    fontSize: 10.75,
    lineHeight: 1.2,
  },
  kpiValue: {
    color: '#1D2433',
    fontSize: 14.5,
    fontWeight: 700,
  },
  chartTitle: {
    color: '#1D2433',
    fontSize: 15,
    fontWeight: 600,
  },
};

export const projectOverviewHeaderSx = {
  minHeight: { xs: 64, sm: 34 },
  mb: 1,
};

export const projectOverviewContentSx = {
  flex: 1,
  minHeight: 0,
};

export const projectOverviewKpiCardSx = {
  p: 1.1,
  height: 64,
  minWidth: 0,
};

export const projectOverviewChartSurfaceSx = {
  p: { xs: 1, sm: 1.25 },
  borderRadius: '12px',
  borderColor: '#E2E4E9',
  boxShadow: 0,
  flex: { lg: 1 },
  minHeight: { lg: 0 },
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

export const projectOverviewChartHeaderSx = {
  minHeight: 34,
};

export const projectOverviewChartViewportSx = {
  width: '100%',
  height: { xs: 250, lg: 'auto' },
  flex: { lg: 1 },
  minHeight: { lg: 160 },
  mt: 0.5,
};

export const projectOverviewEmptySx = {
  height: { xs: 250, lg: 'auto' },
  flex: { lg: 1 },
  minHeight: { lg: 160 },
};
